module.exports = {
      id: "search-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#search",
      toString: function () {
        return this.url;
      }
    }